import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({ 
    name: '', 
    email: '', 
    mobile: '', 
    inquiryType: 'Property Purchase', 
    message: '' 
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // 1. Firebase Firestore mein save karein
      await addDoc(collection(db, "contacts"), {
        name: formData.name,
        email: formData.email,
        mobile: formData.mobile,
        inquiryType: formData.inquiryType,
        message: formData.message,
        createdAt: new Date()
      });

      // 2. Mobile number ko format karein (Country code +91 add karna)
      let formattedPhone = formData.mobile.replace(/\D/g, '');
      if (formattedPhone.length === 10) {
        formattedPhone = '91' + formattedPhone;
      }

      // 3. Professional WhatsApp message tayar karein
      const whatsappMessage = `Hello *${formData.name}*, thank you for reaching out to *PrimiumFlats*! 🏢\n\nWe have successfully received your inquiry regarding *${formData.inquiryType}*. Our real estate expert will connect with you shortly on this number.\n\nWarm regards,\nTeam PrimiumFlats`;
      
      const encodedMessage = encodeURIComponent(whatsappMessage);

      // 4. Customer ke WhatsApp par direct open karein
      window.open(`https://wa.me/${formattedPhone}?text=${encodedMessage}`, '_blank');

      setSubmitted(true);
    } catch (error) {
      console.error("Error sending message: ", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-lg border border-slate-100">
        
        <h1 className="text-3xl font-bold text-gray-800 mb-2 text-center">Get in Touch</h1>
        <p className="text-gray-500 text-center mb-8 text-sm">Have any questions or need assistance? Drop us a message below.</p>

        {submitted ? (
          <div className="my-4 bg-emerald-50 border border-emerald-200 text-emerald-800 px-6 py-4 rounded-2xl text-center font-medium shadow-sm">
            Thank you! Your message has been sent successfully. We will get back to you soon.
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-gray-700 font-medium mb-1 text-xs uppercase tracking-wider">Your Name</label>
              <input 
                type="text" 
                required 
                placeholder="John Doe" 
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-indigo-600 focus:bg-white transition text-sm text-gray-800" 
              />
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-1 text-xs uppercase tracking-wider">Email Address</label>
              <input 
                type="email" 
                required 
                placeholder="john@example.com" 
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-indigo-600 focus:bg-white transition text-sm text-gray-800" 
              />
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-1 text-xs uppercase tracking-wider">Mobile Number</label>
              <input 
                type="tel" 
                required 
                placeholder="9876543210" 
                value={formData.mobile}
                onChange={(e) => setFormData({...formData, mobile: e.target.value})}
                className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-indigo-600 focus:bg-white transition text-sm text-gray-800" 
              />
            </div>

            {/* Inquiry Type Dropdown */}
            <div>
              <label className="block text-indigo-600 font-semibold mb-1 text-xs uppercase tracking-wider">Inquiry Type (Kis cheez ki enquiry hai?)</label>
              <select 
                value={formData.inquiryType}
                onChange={(e) => setFormData({...formData, inquiryType: e.target.value})}
                className="w-full px-4 py-3 bg-slate-50 border border-indigo-200 rounded-xl focus:outline-none focus:border-indigo-600 focus:bg-white transition text-sm text-gray-800 font-medium"
              >
                <option value="Property Purchase">Property Purchase (Flat Kharidna Hai)</option>
                <option value="Site Visit Booking">Site Visit Booking (Dekhne Jana Hai)</option>
                <option value="Home Loan Assistance">Home Loan Assistance (Loan ki Jankari)</option>
                <option value="Selling Property">Selling Property (Apna Flat Bechna Hai)</option>
                <option value="General Inquiry">General Inquiry (Aam Jankari)</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-1 text-xs uppercase tracking-wider">Message</label>
              <textarea 
                rows="4" 
                required 
                placeholder="Write your message here..." 
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:border-indigo-600 focus:bg-white transition text-sm resize-none text-gray-800"
              ></textarea>
            </div>

            <button type="submit" className="w-full bg-indigo-600 text-white py-3.5 rounded-xl font-medium hover:bg-indigo-700 transition shadow-lg shadow-indigo-600/20 text-sm mt-2">
              Send Message & Open WhatsApp
            </button>
          </form>
        )}
      </div>
    </div>
  );
}